module.exports = "pegasus/assets/blocks/column-lp10-themelp1.png";